import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { DialogService } from '@migo-apps/dialogs';
import { Observable, map } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { UserStatus } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class UserBlockedGuard implements CanActivate {
  constructor(
    private authSvc: AuthenticationService,
    private router: Router,
    private dialogSvc: DialogService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authSvc.getUser$().pipe(
      map((user) => {
        if (user && user.status !== UserStatus.BLOCKED) {
          return true;
        }

        this.dialogSvc.openInformationDialog({
          title: 'Cuenta bloqueada',
          message: 'Por favor contacta con soporte',
        });

        return this.router.createUrlTree(['/']);
      })
    );
  }
}
